import Professional from './Professional.vue'

export default {
  [Professional.name]: Professional
}